<template>
  <div id="mark-as-delivered-container">
    <div id="mark-as-delivered-content">
      <div id="submit-button-container" class="text-right p-0" v-if="!(order.vehicle_type.type === 'PTL' && $hasFeature('indent_not_delivered'))">
        <Button
          id="mark-as-delivered-submit-button"
          :disabled="disabled"
          type="primary"
          size="small"
          @click="showPopup"
        >
          <span id="submit-loading-spinner" class="loadspin" v-show="fetching" :key="elementkey"></span>
          {{ $t('INDENT_SUBMIT') }}
        </Button>
      </div>
      <div id="consignees-section" class="row-edit my-10">
        <div id="consignees-badge" class="row-edit-badge" v-if="!Object.values(consigneeDeliveryStatus).some(status => status)">
          <div id="consignees-badge-section" class="row-edit-badge-section">
            <span id="no-destinations-message" v-if="!areConsigneesAvailable">
              No accessible destinations
            </span>
            <template v-else>
              <div v-if="order.vehicle_type.type === 'PTL' && $hasFeature('indent_not_delivered')" class="p-10" data-uid="last-mile-root-actions">
                <div v-if="consignees.length">
                  <div class="last-mile-timeline-item" v-for="(entry, index) in consignees" :key="index">
                    <div style="z-index: 100;">
                      <svgicon name="drop-off-arrow" width="14" height="14" :original="true" />
                    </div>
                    <div v-if="index < consignees.length - 1" class="line"></div>
                    <Collapse accordion class="collapse-no-bg mx-15" v-model="activeCollapseItemId">
                      <CollapseItem :name="index">
                        <template slot="title">
                          <span class="mr-5">{{ getEntityDisplayName(entry) }}</span>
                          <span class="ml-10" style="margin-bottom: 2px;" v-if="isActionCompleted(entry)">
                            <svgicon name="icon-tick" width="14" height="14" :original="true" />
                          </span>
                          <span v-else-if="isNotDelivered(entry)" class="ml-10" style="margin-bottom: 2px;">
                            <svgicon name="red-circle-x-mark" width="14" height="14" :original="true" />
                          </span>
                          <span v-else-if="!canPerformAction(entry, index)" class="ml-10" style="margin-bottom: 2px;">
                            <Tooltip :open-delay="200" effect="dark" placement="bottom-start">
                              <div slot="content">{{ actionErrorMessage(entry) }}</div>
                              <svgicon name="icon-info-circle" width="14" height="14" :original="true" />
                            </Tooltip>
                          </span>
                        </template>
                        <div class="mb-10" v-if="!entry.release_at">
                          <div class="delivery-status-section" style="display: flex; align-items: center; justify-content: space-between;">
                            <RadioGroup v-model="deliveryStatusMap[entry.dropLocationRefId]" @on-change="updateDeliveryStatus(entry, $event)" style="display: flex; gap: 15px;">
                              <Radio :label="false">
                                {{ $t('DELIVERED') }}
                              </Radio>
                              <Radio :label="true" v-if="!entry.unloading_start_at">
                                {{ $t('NOT_DELIVERED') }}
                              </Radio>
                            </RadioGroup>
                            <Button
                              type="primary"
                              size="small"
                              @click="submitSingleDestination(entry)"
                            >
                              {{ $t('INDENT_SUBMIT') }}
                            </Button>
                          </div>
                        </div>
                        <Rows
                          v-if="deliveryStatusMap[entry.dropLocationRefId] === false"
                          :consignee="entry"
                          :orderNo="order.order_number"
                          :movement="order.movement"
                          :datePickerFormat="datePickerFormat"
                          v-on:change="change"
                          :getBackDateConfig="getBackDateConfig"
                          :dispatch="date"
                          :isStorageLocation="isStorageLocation"
                          :hideCheckbox="true"
                        />
                        <div v-if="deliveryStatusMap[entry.dropLocationRefId] === true" class="mt-10">
                          <Form :inline="true" class="form-default">
                            <FormItem :label="$t('REPORTED_AT')" style="width: 50%;">
                              <DatePicker
                                :value="getReportedAt(entry)"
                                @input="updateReportedAt(entry, $event)"
                                :format="datePickerFormat"
                                type="datetime"
                                :placeholder="$t('SELECT_DATE_TIME')"
                                style="width: 100%;"
                                :disabled="!!entry.release_at"
                              />
                            </FormItem>
                          </Form>
                        </div>

                      </CollapseItem>
                    </Collapse>
                  </div>
                </div>
                <div v-else>{{ $t('NO_PICKUPS_DROPS') }}</div>
              </div>
              <template v-else>
                <Rows
                  v-for="(consignee, index) in consignees"
                  :id="`consignee-row-${index}`"
                  :consignee="consignee"
                  :orderNo="order.order_number"
                  :movement="order.movement"
                  :datePickerFormat="datePickerFormat"
                  v-on:change="change"
                  :getBackDateConfig="getBackDateConfig"
                  :dispatch="date"
                  :isStorageLocation="isStorageLocation"
                  v-bind:key="index"
                />
              </template>
            </template>
          </div>
        </div>
      <h4 id="pod-time-note" class="text-grey-dark3 text-sm mb-20" style="font-weight:normal;" v-if="!Object.values(consigneeDeliveryStatus).some(status => status)">{{$t('INDENT_NOTE')}} : {{$t('INDENT_REPORTED_POD_TIME_DEFAULTS_TO_GEO_FENCE_TIME')}}</h4>
      <!-- <div
        id="not-delivered-section"
        class="my-10"
        v-if="order.vehicle_type.type === 'PTL' && $hasFeature('indent_not_delivered')"
      >
        <div v-for="(consignee, index) in consignees" :key="index">
          <Checkbox :id="`not-delivered-checkbox-${index}`" 
                    :value="mappedConsigneeStatus[consignee.destination_id]"
                    @input="updateConsigneeStatus(consignee.destination_id, $event)">
            Not delivered - {{ consignee.dropLocationLabel || consignee.details.name }}
          </Checkbox>
        </div>
      </div> -->

      <div id="truck-detained-alert" class="popover-custom no-border with-shadow"
            placement="bottom" v-if="showAlertFlag">
          <div id="truck-detained-alert-body" class="popover-body bg-white w-300">
            <p id="truck-detained-message">
              {{$t('TRUCK_DETAINED_CHECK',
              { n: this.truckDetainedConfig.no_of_day })}}
            </p>
            <div id="truck-detained-alert-footer" class="popover-footer">
              <Button id="truck-detained-no-button" type="text" size="mini"  @click="showAlertFlag=false">
                {{$t('INDENT_NO')}}
              </Button>
              <Button id="truck-detained-yes-button" type="primary" size="mini" @click="onSubmit">
          {{$t('INDENT_YES_PROCEED')}}
              </Button>
            </div>
          </div>
    </div>
    </div>
  </div>
  <div id="seal-number-section" class="clearfix my-10" v-if="!order.seal_number_at_destination && order.seal_number_at_source">
      <h5 id="seal-number-header" class="header-stripe">
        <span id="seal-number-title">{{$t('INDENT_SEAL_NUMBER').toUpperCase()}}</span>
        <div id="seal-number-actions" class="action">
          <span v-if="sealNo">
            <Button id="seal-number-update-button" type="primary" size="mini" @click="sealNumberCheck">{{$t('INDENT_UPDATE')}}</Button>
          </span>
        </div>
      </h5>
      <div id="seal-number-intact-section" class="my-10">
        <label id="seal-number-intact-label" class="label-md mr-10">{{$t('INDENT_IS_SEAL_NUMBER_INTACT')}}</label>
        <Radio id="seal-number-intact-yes" :label="true" v-model="isSealNumberIntact">
        {{$t('INDENT_YES')}}
        </Radio>
        <Radio id="seal-number-intact-no" :label="false" v-model="isSealNumberIntact">
        {{$t('INDENT_NO')}}
        </Radio>
      </div>
      <Form id="seal-number-form" :inline="true" class="form-default form-triple">
        <FormItem :label="$t('SEAL_NUMBER')">
          <Input id="seal-number-input" :placeholder="$t('ENTER_SEAL_NUMBER')" type="text" v-model="sealNo"></Input>
        </FormItem>
      </Form>
      <div id="seal-number-alert" class="popover-custom no-border with-shadow"
            placement="bottom" v-if="sealAlertFlag">
          <div id="seal-number-alert-body" class="popover-body bg-white w-300">
            <p id="seal-number-alert-message">
              {{$t('CONFIRMATION_POPUP_TRANSPORTER_DEBITED')}}
            </p>
            <div id="seal-number-alert-footer" class="popover-footer">
              <Button id="seal-number-alert-no-button" type="text" size="mini"  @click="sealAlertFlag=false">
                {{$t('INDENT_NO')}}
              </Button>
              <Button id="seal-number-alert-yes-button" type="primary" size="mini" @click="updateSealNumberDetails">
          {{$t('INDENT_YES_PROCEED')}}
              </Button>
            </div>
          </div>
    </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { uniqBy } from 'lodash';
import Header from '../../orders/markasdelivered/Header';
import Rows from '../../orders/markasdelivered/Row';

import { oneDayMilliSeconds } from '../../../constants/order';
import moment from 'moment';

export default {
  props: ['order', 'getBackDateConfig', 'inbound', 'isPrimary', 'datePickerFormat', 'truckDetainedConfig'],
  components: {
    Header,
    Rows,
  },
  data() {
    return {
      disabled: false,
      fetching: false,
      elementkey: 0,
      payload: [],
      sectionType: { DEPOT: 1 },
      showAlertFlag: false,
      isGeofencePopulated: false,
      isSealNumberIntact: null,
      sealNo: null,
      sealAlertFlag: false,
      consigneeDeliveryStatus: {},
      activeCollapseItemId: [],
      deliveryStatusMap: {},
    };
  },
  created() {
    // Initialize delivery status based on is_not_delivered flag
    this.$nextTick(() => {
      if (this.consignees && this.consignees.length) {
        this.consignees.forEach(entry => {
          if (!this.deliveryStatusMap.hasOwnProperty(entry.dropLocationRefId)) {
            this.$set(this.deliveryStatusMap, entry.dropLocationRefId, entry.is_not_delivered || false);
          }
        });
      }
    });
  },
  computed: {
    ...mapGetters({
      currentUserDepots: 'app/depots',
      OtherUserDepots: 'app/otherDepots',
      configurations: 'app/configurations',
      currentUser: 'app/currentUser',
    }),
    date() {
      const maxGateTruckOut = new Date(
        this.$moment.max(
          this.order.sources.map(_sources => this.$moment(_sources.dispatched_at)),
        ),
      );
      // this.$moment(this.startDate).toISOString()
      return maxGateTruckOut;
    },
    hasGateAccess() {
      return (this.currentUser && this.currentUser.gate_associates_ids) && this.currentUser.gate_associates_ids.length;
    },
    areConsigneesAvailable() {
      return !!(this.consignees && this.consignees.length);
    },
    consignees() {
      const destinations = (this.order && this.order.destinations) || [];
      if (this.inbound && this.order && this.order.destinations && this.order.destinations.length) {
        const applyFilter = this.hasGateAccess ? this.hasUserDepotGateAccess : this.hasUserDepotAccess;
        const accessDestinations = this.order.destinations.filter(applyFilter);
        if (this.hasGateAccess || this.isMultiDropConfig) {
          const gateWiseGroup = this.getGateWiseDestinations(accessDestinations);
          if (this.isStorageLocation) {
            return this.storageLocationGroup(gateWiseGroup);
          }
          return gateWiseGroup;
        }
        return uniqBy(accessDestinations, 'location_id');
      } else if (this.isMultiDropConfig) {
        const gateWiseGroup = this.getGateWiseDestinations(destinations);
        if (this.isStorageLocation) {
          return this.storageLocationGroup(gateWiseGroup);
        }
        return gateWiseGroup;
      }
      const gateWiseGroup = uniqBy(destinations, 'location_id');
      if (this.isStorageLocation) {
        return this.storageLocationGroup(gateWiseGroup);
      }
      return gateWiseGroup;
    },
    isStorageLocation() {
      return this.$hasFeature('enable_storage_location') || false;
    },
    isMultiDropConfig() {
      return this.configurations && this.configurations.multi_drop_at_gate_level;
    },
    mappedConsigneeStatus() {
      const status = {};
      this.consignees.forEach(consignee => {
        status[consignee.gate_id] = this.consigneeDeliveryStatus[consignee.gate_id] || false;
      });
      return status;
    },
  },
  methods: {
    storageLocationGroup(gateWiseGroup) {
      const {
        groupedStorage,
        nonStorageItems,
      } = gateWiseGroup.reduce(
        (acc, item) => {
          if (item.isStorageLocation) {
            const locId = item.location_id.toString() || '';

            if (!acc.groupedStorage[locId]) {
              acc.groupedStorage[locId] = {
                items: [],
                names: [],
                ids: [],
              };
            }
            acc.groupedStorage[locId].items.push(item);
            acc.groupedStorage[locId].names.push(item.gateName || '');
            acc.groupedStorage[locId].ids.push(item.gate_id.toString());
          } else {
            acc.nonStorageItems.push(item);
          }
          return acc;
        },
        {
          groupedStorage: {},
          nonStorageItems: [],
        },
      );
        // Build combined storage entries per location_id
      const combinedStorageObjects = Object.values(groupedStorage).map(group => ({
        ...group.items[0], // use first as base
        dropLocationLabel: `${group.items[0].details.city} - ${group.names.join(',')} Storage Location`,
        combined_storage_gate_ids: group.ids.join(','),
      }));

      const final = [...combinedStorageObjects, ...nonStorageItems];
      return final;
    },
    getGateWiseDestinations(destinations) {
      return uniqBy(destinations.map((dropLocation) => {
        let dropLocationRefId = dropLocation.details.reference_id || '-';
        const dropLocationName = dropLocation.details.name || '-';
        let gateDetails = null;
        if (dropLocation.gate_id) {
          const dropDestinationDetails = this.OtherUserDepots.find(val => val.id === dropLocation.location_id);
          if (dropDestinationDetails && dropDestinationDetails.gates) {
            gateDetails = dropDestinationDetails ? dropDestinationDetails.gates.find(gate => gate.id === dropLocation.gate_id) :
              { reference_id: dropLocation.details.reference_id };
            dropLocationRefId = `${gateDetails && gateDetails.reference_id} - ${dropLocationName}`;
          }
        }
        return { ...dropLocation,
          dropLocationRefId,
          dropLocationName,
          isStorageLocation: (gateDetails && gateDetails.is_storage_location) || false,
          gateName: (gateDetails && gateDetails.name) || '',
          dropLocationLabel: `${dropLocationName} - ${dropLocationRefId}` };
      }), 'dropLocationRefId');
    },
    updateConsigneeStatus(destinationId, value) {
      this.$set(this.consigneeDeliveryStatus, destinationId, value);
    },
    change(selected) {
      const payload = this.payload;
      const idx = payload.findIndex((val) => {
        if (this.isMultiDropConfig || this.hasGateAccess || this.isStorageLocation) {
          return val.destination_id === selected.destination_id &&
              val.gate_id === selected.gate_id;
        }
        return val.destination_id === selected.destination_id;
      });
      if (idx !== -1) {
        payload.splice(idx, 1, selected);
      } else {
        payload.push(selected);
      }
      if (payload.some(val => !!val.geofence_populated)) {
        this.isGeofencePopulated = true;
      } else {
        this.isGeofencePopulated = false;
      }
    },
    hasUserDepotGateAccess(destination) {
      const gateIds = this.currentUser.gate_associates_ids;
      return destination.type === this.sectionType.DEPOT && gateIds.includes(destination.gate_id);
    },
    hasUserDepotAccess(destination) {
      const hasDepotAccess =
      this.currentUserDepots && this.currentUserDepots.length;
      const depotIds = this.currentUserDepots.map(_depot => _depot.id);
      return destination.type === this.sectionType.DEPOT &&
      hasDepotAccess ? depotIds.includes(destination.location_id) : true;
    },
    arrivedDateValidation(time, reportedDateAllow, truckDispatched) {
      if (reportedDateAllow) {
        return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
      }
      return time.getTime() > Date.now() ||
        time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
    },
    dispatchedDateValidation(time, releaseDateAllow, dispatch, truckDispatched) {
      if (releaseDateAllow) {
        return time.getTime() < Date.now() - oneDayMilliSeconds || time.getTime() > new Date();
      }
      if (!dispatch) {
        return time.getTime() > Date.now() ||
          time.getTime() < new Date(truckDispatched).getTime() - oneDayMilliSeconds;
      }
      return time.getTime() > new Date() ||
        time.getTime() < new Date(dispatch).getTime() - oneDayMilliSeconds;
    },
    toggle() {
      this.disabled = true;
      this.fetching = true;
    },
    toggleback() {
      this.disabled = false;
      this.fetching = false;
    },
    computeDiffBetweenDays(startDay, endDay) {
      if (!startDay || !endDay) {
        return 0;
      }
      return moment(endDay).diff(moment(startDay), 'days');
    },
    showPopup() {
      const istruckDetainedConfigEnabled = this.truckDetainedConfig &&
       this.truckDetainedConfig.enabled;
      if (istruckDetainedConfigEnabled) {
        // compute diff of truck in and truck out and compare if greater than the configured n
        const isExceedThreshold = this.payload
          .filter(consignee => consignee.reported_at && consignee.release_at)
          .find(consignee =>
            this.computeDiffBetweenDays(consignee.reported_at, consignee.release_at) >=
           this.truckDetainedConfig.no_of_day);
        if (isExceedThreshold) {
          this.showAlertFlag = true;
        }
      }
      if (!(this.order.seal_number_at_destination) && this.$hasFeature('allow_seal_number') &&
      this.order.vehicle_type.seal_available) {
        this.$errorMessage({ message: this.$t('ENTER_DESTINATION_SEAL_NUMBER') });
        this.disabled = true;
        return;
      }
      if (!this.showAlertFlag) {
        this.onSubmit();
      }
    },
    async onSubmit() {
      this.showAlertFlag = false;
      this.toggle();
      try {
        if (this.payload.some(source => new Date(source.reported_at).getTime() > new Date().getTime()) ||
          this.payload.some(source => new Date(source.release_at).getTime() > new Date().getTime())) {
          this.$errorMessage({ message: this.$t('INDENT_REPORTED_RELEASE_FUTURE_TIME_ERROR_MSG') });
          this.toggleback();
          return;
        }
        if (this.payload.some(source => source.reported_at < this.date)) {
          this.$errorMessage({ message: this.$t('INDENT_REPORTED_AFTER_DISPATCHED_ERROR_MSG') });
          this.toggleback();
          return;
        }
        if (this.payload.some(source => source.release_at < source.reported_at)) {
          this.$errorMessage({ message: this.$t('INDENT_RELEASE_AFTER_REPORTED_ERROR_MSG') });
          this.toggleback();
          return;
        }
        if (this.payload.some(source => source.unloading_start_at > source.release_at ||
          source.unloading_start_at < source.reported_at)) {
          this.$errorMessage({ message: this.$t('INDENT_UNLOADING_START_BTWN_REPORTED_RELEASE') });
          this.toggleback();
          return;
        }
        if (this.payload.some(source => source.unloading_end_at < source.unloading_start_at ||
          source.unloading_end_at > source.release_at)) {
          this.$errorMessage({ message: this.$t('INDENT_UNLOADING_END_BTWN_UNLOADING_START_RELEASE') });
          this.toggleback();
          return;
        }
        const payload = this.payload.flat();
        const id = this.order.order_number;
        
        // Separate delivered and not delivered entries

        const notDeliveredPayload = [];
        
        this.consignees.forEach((entry) => {
          if (this.deliveryStatusMap[entry.dropLocationRefId] === true) {
            // Not delivered - construct payload with reported_at
            notDeliveredPayload.push({
              destination_id: entry.location_id,
              gate_id: entry.gate_id,
              reported_at: entry.reported_at || new Date().toISOString(),
            });
          }
        });
        
        let result;
        
        // Handle not delivered entries
        if (notDeliveredPayload.length > 0) {
          result = await this.$store.dispatch('order/notDelivered', {
            id,
            data: notDeliveredPayload,
          });
        } else {
          // Handle only delivered entries
          result = await this.$store.dispatch('order/deliver', {
            id,
            data: payload,
          });
        }
        // triggerIndentStatusUpdate
        await this.$store.dispatch('paymentsV2/updateIndentStatus', {
          id,
        });
        if (result && result.error) {
          this.toggleback();
          this.$error({ message: result.error });
        } else if (result.order_number || result.order_no) {
          const hasNotDelivered = notDeliveredPayload.length > 0;
          
          this.$emit('done', hasNotDelivered ? 'notDelivered' : 'markasdelivered');
          if (this.$hasFeature('exim_enabled') && result.master_indent) {
            await this.$store.dispatch('exim/fetchChildIndent', { indentNo: result.master_indent });
          }
          this.$success({
            message: hasNotDelivered 
              ? this.$t('INDENT_NOT_DELIVERED_TOAST_MSG', { order_number: result.order_no })
              : this.$t('INDENT_MARK_AS_DELIVERED_TOAST_MSG', { order_number: result.order_number }),
          });
          this.toggleback();
        }
        return result;
      } catch (e) {
        this.toggleback();
        return e;
      }
    },
    sealNumberCheck() {
      if ((this.sealNo.toLowerCase() !== this.order.seal_number_at_source) ||
        !this.isSealNumberIntact) {
        this.sealAlertFlag = true;
      } else {
        this.updateSealNumberDetails();
      }
    },
    async updateSealNumberDetails() {
      try {
        const { order_number: orderNo } = this.order;
        const data = {
          seal_no: this.sealNo,
          update_in: 'destination',
          is_seal_number_intact: this.isSealNumberIntact,
        };
        const result = await this.$store.dispatch('order/updateSealNumberDetails', {
          orderNo,
          data,
        });
        if (result && result.order_no) {
          this.$emit('closeDrawer');
          this.$success({
            message: this.$t('INDENT_SEAL_NUMBER_UPDATE_TOAST_MSG', { order_number: result.order_no }),
          });
        } else if (result && result.error) {
          this.$error({
            message: result.error,
          });
        }
      } catch (error) {
        // console.log(error);
      }
    },
    getEntityDisplayName(entry) {
      return entry.dropLocationLabel || entry.details.name;
    },
    isActionCompleted(entry) {
      return entry.release_at && !entry.is_not_delivered;
    },
    isNotDelivered(entry) {
      return entry.is_not_delivered;
    },
    canPerformAction(entry, index) {
      return true;
    },
    actionErrorMessage(entry) {
      return '';
    },
    getDeliveryStatus(destinationId) {
      return this.deliveryStatusMap.hasOwnProperty(destinationId) ? this.deliveryStatusMap[destinationId] : false;
    },
    updateDeliveryStatus(entry, isNotDelivered) {
      this.$set(this.deliveryStatusMap, entry.dropLocationRefId, isNotDelivered);
      this.$set(entry, 'is_not_delivered', isNotDelivered);
    },
    getReportedAt(entry) {
      const payloadEntry = this.payload.find(p => 
        p.destination_id === entry.location_id && p.gate_id === entry.gate_id
      );
      return payloadEntry ? payloadEntry.reported_at : entry.reported_at;
    },
    updateReportedAt(entry, date) {
      const payloadIndex = this.payload.findIndex(p => 
        p.destination_id === entry.location_id && p.gate_id === entry.gate_id
      );
      
      if (payloadIndex !== -1) {
        this.$set(this.payload[payloadIndex], 'reported_at', date);
      } else {
        this.payload.push({
          destination_id: entry.location_id,
          gate_id: entry.gate_id,
          reported_at: date
        });
      }
    },
    canSubmitDestination(entry) {
      const isDelivered = this.deliveryStatusMap[entry.dropLocationRefId] === false;
      const isNotDelivered = this.deliveryStatusMap[entry.dropLocationRefId] === true && entry.reported_at;
      return isDelivered || isNotDelivered;
    },
    async submitSingleDestination(entry) {
      const id = this.order.order_number;
      const isNotDelivered = this.deliveryStatusMap[entry.dropLocationRefId] === true;
      
      try {
        let result;
        if (isNotDelivered) {
          result = await this.$store.dispatch('order/notDelivered', {
            id,
            data: [{
              destination_id: entry.location_id,
              gate_id: entry.gate_id,
              reported_at: this.getReportedAt(entry) || new Date().toISOString(),
            }],
          });
        } else {
          // const deliveredPayload = this.payload.filter(p => 
          //   p.destination_id === entry.location_id && p.gate_id === entry.gate_id
          // );
          result = await this.$store.dispatch('order/deliver', {
            id,
            data: this.payload,
          });
        }
        
        if (result && result.error) {
          this.toggleback();
          this.$error({ message: result.error });
        } else if (result.order_number || result.order_no) {
          this.$emit('done', isNotDelivered ? 'notDelivered' : 'markasdelivered');
          if (this.$hasFeature('exim_enabled') && result.master_indent) {
            await this.$store.dispatch('exim/fetchChildIndent', { indentNo: result.master_indent });
          }
          this.$success({
            message: isNotDelivered 
              ? this.$t('INDENT_NOT_DELIVERED_TOAST_MSG', { order_number: result.order_no })
              : this.$t('INDENT_MARK_AS_DELIVERED_TOAST_MSG', { order_number: result.order_number }),
          });
          this.toggleback();
        }
      } catch (error) {
        this.$error({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
  watch: {
    activeCollapseItemId(newValue) {
      if (newValue.length === 2) {
        this.activeCollapseItemId.splice(0, 1);
      }
    }
  }
};
</script>

<style lang="scss">
div[data-uid='last-mile-root-actions'] {
  display: flex;
  flex-direction: column;
  max-height: 600px;
  overflow-y: auto;
  overflow-x: hidden;
  .last-mile-timeline-item {
    position: relative;
    display: flex;
    .dot, .dot1 {
      width: 19px;
      height: 18px;
      border-radius: 50%;
      position: relative;
      z-index: 100;
      .arrow-tl, .arrow-br {
        font-size: 13px;
        font-weight: bold;
        position: absolute;
        top: 1px;
        color: white;
        left: 3px;
      }
    }
    .dot {
      background-color: #63C1F8;
    }
    .dot1 {
      background-color: #0076DD;
      .arrow-br {
        top: 0px;
      }
    }
    .line {
      width: 2px;
      flex-grow: 1;
      position: absolute;
      top: 8px;
      bottom: 0;
      left: 7px;
      border-left: 1px dashed #8A8A9E50;
      z-index: 1;
    }
    .content {
      padding: 0 10px 10px;
      border-radius: 5px;
      &-header {
        color: #8A8A9E;
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 5px;
      }
      &-sub-header {
        color: #D5DAF4;
        font-weight: 700;
        font-size: 12px;
        .sub-content {
          position: relative;
          left: 170px;
          top: -13px;
          font-size: 10px;
          font-weight: 400;
          color: #8A8A9E;
        }
      }
    }
  }

  .last-mile-flex-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    background-color: rgb(238, 238, 238);
    .last-mile-row {
      display: flex;
      justify-content: space-between;
      .last-mile-span {
        flex-basis: 50%;
        padding: 5px;
      }
    }
  }
  .el-collapse {
    width: 100%;
    border-top: 0px;
    border-bottom: 0px;
    &-item__arrow {
      &:before {
        display: none;
      }
    }
    &-item__header {
      border: none !important;
      top: -8px;
      height: 40px !important;
      background-color: transparent;
    }
    &-item__content {
      line-height: 2.1 !important;
    }
    &-item__arrow {
      display: none;
    }
    &.collapse-no-bg {
      border: none;
      .el-collapse {
        &-item {
          margin-top: 5px;
          &.is-active {
            .el-collapse-item {
              &__header {
                background-color: transparent;
                border-left: none;
              }
            }
          }
          &__header {
            height: 35px;
            padding: 0 10px 10px 25px;
            position: relative;
            font: 1.2rem/17px 'OpenSans-Semibold';
            color: #234357;
            text-transform: uppercase;
            border-left: 1px solid #D6D6D6;
            &:after {
              content: '';
              width: 2px;
              height: 35px;
              position: absolute;
              top: -1px;
              left: 0;
            }
            .icon-title {
              margin: 0 5px;
            }
            .status-title {
              position: absolute;
              right: 50px;
              line-height: 12px;
            }
            &:hover {
              background-color: #EFEFEF;
            }
          }
          &__wrap {
            border-bottom: none;
          }
          &__content {
            padding: 10px 15px;
          }
        }
      }
    }
  }
}
</style>
